import { useContext } from "react";
import { Hook } from "sonobello.utilities.react";

import AppContext from "../../AppContext";
import ICenter from "../../types/ICenter";
import UseGetBookingCenterOptions from "../hooks/useGetBookingCenterOptions";

/** A hook which obtains the booking candidate centers using the state of the session App Context. */
const AppContextUseGetBookingCenterOptions: Hook<ICenter[]> = () => {
  const { patient, defaultCenter } = useContext(AppContext);
  return UseGetBookingCenterOptions({
    centerId: defaultCenter.id,
    patientPostalCode: patient.zipCode ?? null,
    centerPostalCode: defaultCenter.postalCode
  });
};

export default AppContextUseGetBookingCenterOptions;
